import React, { useState } from "react";
import styles from "../../Application.module.scss";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Surcharge from "./Pricing/Surcharge";
import OtherFees from "./Pricing/OtherFees";
import Tiered from "./Pricing/Tiered";
import DualPricing from "./Pricing/DualPricing";
import FlatRate from "./Pricing/FlatRate";
import ICPlus from "./Pricing/ICPlus";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";
import Ach from "./Pricing/Ach";
import useCommonStore from "../../../../stores/common";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import KurvPricing from "./Pricing/KurvPricing";

function Pricing({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery(768);
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const hasCardPricing =
    Boolean(appData?.qualifiedtype) && appData.qualifiedtype !== "ach";
  const hasAchPricing =
    appData?.qualifiedtype === "ach" || Boolean(appData?.is_ach);

  const renderPricing = () => {
    if (appData.qualifiedtype === "tiered") return <Tiered appData={appData} />;
    if (appData.qualifiedtype === "surcharge")
      return <Surcharge appData={appData} />;
    if (appData.qualifiedtype === "dual_pricing")
      return <DualPricing appData={appData} />;
    if (appData.qualifiedtype === "flat_rate")
      return <FlatRate appData={appData} />;
    if (appData.qualifiedtype === "ic_plus")
      return <ICPlus appData={appData} />;
    if (appData.qualifiedtype === "kurv_pricing")
      return <KurvPricing appData={appData} />;
    return null;
  };

  return (
    <div
      className={`${isMobile ? styles.mobile_business_info : styles.pricing} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div
        className={isMobile ? styles.business_info_header : styles.head}
        onClick={toggleExpanded}
      >
        {isMobile ? (
          <>
            <CaretRight24
              className={`${styles.caret_icon} ${expanded ? styles.expanded : ""}`}
            />
            <h4>Pricing</h4>
          </>
        ) : (
          <>
            <ButtonIcon>
              <CaretRight24 className={expanded ? styles.expanded : ""} />
            </ButtonIcon>
            <h5>Pricing</h5>
          </>
        )}
      </div>

      <div
        className={`${isMobile ? styles.mobile_content : styles.body} ${expanded ? (isMobile ? styles.expanded : styles.body_expanded) : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expanded && (
          <>
            {hasCardPricing && renderPricing()}
            {hasCardPricing && <OtherFees appData={appData} />}
            {hasAchPricing && (
              <Ach appData={appData} hidePricingModel={hasCardPricing} />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Pricing;
